/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconActivity = createReactComponent("activity", "IconActivity", [
  ["path", { d: "M3 12h4l3 8l4 -16l3 8h4", key: "svg-0" }]
]);

export { IconActivity as default };
//# sourceMappingURL=IconActivity.js.map
